var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("AllDocumentsList", {
    attrs: {
      companyId: _vm.company.id,
      currentUser: _vm.currentUser,
      query: _vm.query,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }